export const getRouteDataForWorkItem = (workItem, locale) => {
  const category = workItem.category

  if (!category) {
    return false
  }

  if (workItem.slug) {
    return {
      name: `${category}.${locale}`,
      params: { slug: workItem.slug }
    }
  }

  return {
    name: `${category}IdFallback.${locale}`,
    params: { id: workItem.id }
  }
}
